import Vue from 'vue';
import Vuex from 'vuex';
import centerAccount from './models/centerAccount';
import childMembership from './models/childMembership/childMembership';
import checkIn from './models/checkIn';
import payments from './models/childMembership/payment';
import childCourse from './models/childCourse/childCourse';
import parentCourse from './models/parentCourse';
import parentMembership from './models/parentMembership';
import blocking from './models/childCourse/blocking';
import policy from './models/policy';
import timeTable from './models/timeTable';
import instructor from './models/instructor';
import accountAuth from './models/accountAuth';
import dialogStatus from './custom-dialog';
import createPersistedState from 'vuex-persistedstate';
import restrictFunction from './models/restrictFunction';
import { fiflboxApi } from '@/utils/api';
import { ACCOUNT_ROLE } from '@/constants';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    centerAccount,
    payments,
    childMembership,
    checkIn,
    childCourse,
    blocking,
    parentCourse,
    parentMembership,
    policy,
    timeTable,
    instructor,
    accountAuth,
    restrictFunction,
    dialogStatus
  },
  plugins: [
    createPersistedState({
      key: 'FIFLBOX:store',
      paths: ['role', 'timeTable', 'instructor.instructorToken']
    })
  ],
  state: {
    instructors: [],
    vaildMembers: [],
    alerts: [],
    role: 0,
    isOwnerAccount: true
  },
  mutations: {
    setInstructors(state, instructors) {
      state.instructors = instructors;
    },
    setVaildMembers(state, vaildMembers) {
      state.vaildMembers = vaildMembers;
    },
    setAlerts(state, alerts) {
      state.alerts = alerts;
    },
    setRole(state, role) {
      state.role = role;
    },
    setIsOwnerAccount(state, role) {
      state.isOwnerAccount = role === ACCOUNT_ROLE.OWNER;
    }
  },
  getters: {
    getInstructors: state => {
      return state.instructors;
    },
    getInstructorByIds: state => ids => {
      return state.instructors.filter(instructor =>
        ids.includes(instructor.id)
      );
    },
    getVaildMembers(state) {
      return state.vaildMembers;
    },
    getAlerts(state) {
      return state.alerts;
    },
    getRole(state) {
      return state.role;
    },
    getIsOwnerAccount(state) {
      return state.isOwnerAccount;
    }
  },
  actions: {
    async syncInstructors({ commit }) {
      let { data: instructors } = await fiflboxApi.v2.getCenterInstructors();

      commit('setInstructors', instructors);
    },
    async syncVaildMembers({ commit }) {
      try {
        let { data: members } = await fiflboxApi.v1.getEnrollmentMembers({
          is_valid: 1,
          status: 'APPROVAL'
        });
        commit('setVaildMembers', members);
      } catch (err) {
        console.log(err);
      }
    },
    async syncAlerts({ commit }) {
      try {
        let { data: alerts } = await fiflboxApi.v1.getFiflboxNotice();

        commit('setAlerts', alerts);
      } catch (err) {
        console.log(err);
      }
    }
  }
});
